
import React from 'react';
import './App.css';
import Header from './components/header';
import Footer from './components/footer';
import AgeVerification from './components/ageverif';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Main from './pages/main';
import Catalog from './pages/catalog';
import Details from './pages/details';
import AboutUs from './pages/aboutus';
import Pap from './pages/pap';
import Help from './pages/help';
import Cart from './pages/cart';
import Politic from './pages/politic'; 
import UserAgreement from './pages/userAgreement'; 
import RulesOfSite from './pages/rulesOfSite'; 
import { Toaster } from 'react-hot-toast';
import { CartProvider } from './contexts/CartContext'; 
import Reviews from './pages/reviews';
import Blogs from './pages/blogs';
import BlogPage from './pages/blogspage';


const Layout = () => {
  return (
    <>
      <Header />
      <main className="content">
        <Outlet /> {/* Здесь будут рендериться вложенные маршруты */}
      </main>
      <Footer />
      <AgeVerification />
      <Toaster position="top-center" />
    </>
  );
};

function App() {
  return (
    <Router>
      <CartProvider>
        <div className="App">
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Main />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/catalog/:slug" element={<Details />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/purchase-and-payment" element={<Pap />} />
              <Route path="/help" element={<Help />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/politic" element={<Politic />} /> {/* Маршрут для политики конфиденциальности */}
              <Route path="/user-agreement" element={<UserAgreement />} /> {/* Маршрут для пользовательского соглашения */}
              <Route path="/rules-of-site" element={<RulesOfSite />} /> {/* Маршрут для правил работы сайта */}\
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:link" element={<BlogPage />} />
            </Route>
          </Routes>
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;
